module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company_notice_detail"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("戻る")])])]), (_vm.isGetCompanyNotice) ? _c('div', {
    staticClass: "company_notice"
  }, [(_vm.company_notice) ? [_c('div', {
    staticClass: "company_notice_inner"
  }, [_c('p', {
    staticClass: "company_notice_inner-issue_date"
  }, [_vm._v("発行年月日 " + _vm._s(_vm._f("formatDate")(_vm.company_notice.notice_start_date)))]), _c('h2', {
    staticClass: "company_notice_inner-title"
  }, [_vm._v(_vm._s(_vm.company_notice.notice_title))]), _c('p', {
    staticClass: "company_notice_inner-body"
  }, [_vm._v(_vm._s(_vm.company_notice.notice_content))])])] : [_c('div', {
    staticClass: "company_notice_inner no-content"
  }, [_vm._m(0), _c('button', {
    staticClass: "company_notice_inner-button",
    on: {
      "click": function($event) {
        _vm.goCompanyNoticeList()
      }
    }
  }, [_vm._v("全社通達一覧に戻る")])])]], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "company_notice_inner-title"
  }, [_vm._v("この全社通達は"), _c('br'), _vm._v("削除されたみたいニャン…")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63f8b34e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/company-notice-detail.pug
// module id = 1421
// module chunks = 1